import React from "react";
import icon from "../../../assets/Icon.svg";
import "./AuditProtocol.css";

interface AuditProtocolProps {
  countryCode: string;
  onDownloadLastReport: () => void;
}

const AuditProtocol: React.FC<AuditProtocolProps> = ({
  countryCode,
  onDownloadLastReport,
}) => {
  const isIndia = countryCode === "+91";

  return (
    <div className="audit-protocol-wrapper">
      <aside
        className={`audit-protocol ${
          isIndia
            ? "audit-protocol--india"
            : "audit-protocol--international"
        }`}
        aria-labelledby="audit-protocol-title"
      >
        <div className="audit-protocol__spacer" />

        <div className="audit-protocol__content">
          <div className="audit-protocol__badge">
            <img
              src={icon}
              alt=""
              className="audit-protocol__icon"
            />
          </div>

          <h2
            id="audit-protocol-title"
            className="audit-protocol__title"
          >
            The Audit Protocol
          </h2>

          <p className="audit-protocol__description">
            Our proprietary engine cross-references your handle's
            engagement velocity with current platform algorithms to
            deliver a precision roadmap for Q4 growth.
          </p>
        </div>
      </aside>

      <div
        className={`audit-download-container ${
          isIndia
            ? "audit-download-container--india"
            : "audit-download-container--international"
        }`}
      >
        <span>
          If you want to download the last report,
        </span>

        <button
          type="button"
          className="audit-download-link"
          onClick={onDownloadLastReport}
        >
          CLICK HERE
        </button>
      </div>
    </div>
  );
};

export default AuditProtocol;